import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { observable } from 'mobx'
import { scaleLinear, scaleBand } from 'd3-scale'
import _ from 'lodash'
import { translate } from 'utils'
import XAxis from './XAxis'
import YAxis from './YAxis'
import SeriesList from './SeriesList'
import BarHover from './BarHover'

@inject('uiStore', 'selectionStore') @observer
class ChartSVG extends Component {
  @observable width
  @observable height

  calculateSize () {
    this.width = this.refs.svg.clientWidth
    this.height = this.refs.svg.clientHeight
  }

  componentDidMount () {
    this.calculateSize()
  }

  componentWillUpdate () {
    this.calculateSize()
  }

  render () {
    const {
      color,
      analysis,
      chartMargin,
      seriesNames,
      uiStore,
      selectionStore
    } = this.props

    // on first render width will not be set, so just render the container
    if (_.isNil(this.width)) {
      return (
        <div className='svg-container' style={{ height: '130px' }} ref='svg' />
      )
    }

    const width = Math.max(this.width - chartMargin.left - chartMargin.right, 1)
    const height = Math.max(this.height - chartMargin.top - chartMargin.bottom, 1)

    // use scaleBand to map age groups to regions along the X axis
    const xScale = scaleBand()
      .domain(_.map(analysis.pyramids.total, 'age'))
      .range([0, width])
      .padding(0.1)

    // translate each age group using the xScale, plus half the bandwidth
    // to center it.
    const xScaleTranslate = pyramid =>
      translate(xScale(pyramid.age) + xScale.bandwidth() / 2 - 0.5, 0)

    const barWidth = xScale.bandwidth() / seriesNames.length

    // calculate bar's position relative to the overall age group's position
    const barX = pyramid =>
      xScale(pyramid.age) +
      barWidth * seriesNames.indexOf(pyramid.gender)

    // base number of y ticks on the height of the chart
    const yTickCount = Math.ceil(height / 40)

    const yScale = scaleLinear()
      .domain([0, analysis.maxValue])
      .range([0, height])
      .nice(yTickCount)

    return (
      <div
        data-resize={JSON.stringify([
          uiStore.windowSize,
          selectionStore.item === null
        ])}
        className='svg-container'
        style={{ height: '130px' }}
        ref='svg'
      >
        <svg>
          <g fill='none' transform={translate(chartMargin.left, chartMargin.top)}>
            <XAxis
              height={height}
              analysis={analysis}
              xScaleTranslate={xScaleTranslate}
              seriesNames={seriesNames}
            />
            <BarHover
              analysis={analysis}
              height={height}
              barX={barX}
              barWidth={barWidth}
            />
            <YAxis
              yScale={yScale}
              yTickCount={yTickCount}
              width={width}
              height={height}
            />
            <SeriesList
              color={color}
              seriesNames={seriesNames}
              height={height}
              xScale={xScale}
              yScale={yScale}
              analysis={analysis}
            />
          </g>
        </svg>
      </div>
    )
  }
}

export default ChartSVG
